import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { Session, User } from "@supabase/supabase-js";
import { supabase } from "@/lib/supabase";
import { usePostHog } from "posthog-js/react";
export function useAuth() {
  const $ = _c(7);
  const [user, setUser] = useState(null);
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const posthog = usePostHog();
  let t0;
  let t1;
  if ($[0] !== posthog) {
    t0 = () => {
      const getSession = async () => {
        const {
          data: t2
        } = await supabase.auth.getSession();
        const {
          session: session_0
        } = t2;
        setSession(session_0);
        setUser(session_0?.user ?? null);
        setLoading(false);
      };
      getSession();
      const {
        data: t3
      } = supabase.auth.onAuthStateChange(async (event, session_1) => {
        setSession(session_1);
        setUser(session_1?.user ?? null);
        if (session_1?.user) {
          posthog.identify(session_1.user.id, {
            email: session_1.user.email
          });
        }
        setLoading(false);
      });
      const {
        subscription
      } = t3;
      return () => subscription.unsubscribe();
    };
    t1 = [posthog];
    $[0] = posthog;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== loading || $[4] !== session || $[5] !== user) {
    t2 = {
      user,
      session,
      loading,
      signOut: _temp
    };
    $[3] = loading;
    $[4] = session;
    $[5] = user;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
function _temp() {
  return supabase.auth.signOut();
}